import {
    FETCH_EVENTS_START,
    FETCH_EVENTS_SUCCESS,
    FETCH_EVENTS_FAILURE,
    FETCH_SINGLE_EVENT_START,
    FETCH_SINGLE_EVENT_SUCCESS,
    FETCH_SINGLE_EVENT_FAILURE,
    CREATE_CHECKOUT_SESSION_START,
    CREATE_CHECKOUT_SESSION_SUCCESS,
    CREATE_CHECKOUT_SESSION_FAILURE,
    SET_BOOKING_PAYMENT_SUCCESS_START,
    SET_BOOKING_PAYMENT_SUCCESS_SUCCESS,
    SET_BOOKING_PAYMENT_SUCCESS_FAILURE,
    SET_BOOKING_PAYMENT_FAILED_START,
    SET_BOOKING_PAYMENT_FAILED_SUCCESS,
    SET_BOOKING_PAYMENT_FAILED_FAILURE,
    FETCH_MY_EVENT_BOOKINGS_START,
    FETCH_MY_EVENT_BOOKINGS_FAILURE,
    FETCH_MY_EVENT_BOOKINGS_SUCCESS
} from "../actions/ActionConstant";

const initialState = {
    events: {
        data: {},
        loading: true,
        error: false,
    },
    singleEvent: {
        data: {},
        loading: true,
        error: false,
        inputData: {},
        loadingButtonContent: null,
        buttonDisable: false,
    },
    session: {
        data: {},
        loading: true,
        error: false,
    },
    bookingSuccess: {
        data: {},
        loading: true,
        error: false,
        inputData: {},
        loadingButtonContent: null,
        buttonDisable: false,
    },
    bookingFailed: {
        data: {},
        loading: true,
        error: false,
        inputData: {},
        loadingButtonContent: null,
        buttonDisable: false,
    },
    myEventBookings: {
        data: {},
        inputData: {},
        loading: true,
        error: false,
    }
};

const EventReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_EVENTS_START:
            return {
                ...state,
                events: {
                    data: {},
                    loading: true,
                    error: false,
                },
            };
        case FETCH_EVENTS_SUCCESS:
            return {
                ...state,
                events: {
                    data: action.data,
                    loading: false,
                    error: false,
                },
            };
        case FETCH_EVENTS_FAILURE:
            return {
                ...state,
                events: {
                    data: {},
                    loading: false,
                    error: true,
                },
            };

        case FETCH_SINGLE_EVENT_START:
            return {
                ...state,
                singleEvent: {
                    inputData: action.data,
                    data: {},
                    loading: true,
                    error: false,
                    loadingButtonContent: "Loading... Please wait",
                    buttonDisable: true,
                },
            };
        case FETCH_SINGLE_EVENT_SUCCESS:
            return {
                ...state,
                singleEvent: {
                    data: action.data,
                    loading: false,
                    error: false,
                    inputData: {},
                    loadingButtonContent: null,
                    buttonDisable: false,
                },
            };
        case FETCH_SINGLE_EVENT_FAILURE:
            return {
                ...state,
                singleEvent: {
                    data: {},
                    loading: true,
                    error: action.error,
                    inputData: {},
                    loadingButtonContent: null,
                    buttonDisable: false,
                },
            };

        case CREATE_CHECKOUT_SESSION_START:
            return {
                ...state,
                session: {
                    inputData: action.data,
                    data: {},
                    loading: true,
                    error: false,
                    loadingButtonContent: "Loading... Please wait",
                    buttonDisable: true,
                },
            };
        case CREATE_CHECKOUT_SESSION_SUCCESS:
            return {
                ...state,
                session: {
                    data: action.data,
                    loading: false,
                    error: false,
                    inputData: {},
                    loadingButtonContent: null,
                    buttonDisable: false,
                },
            };
        case CREATE_CHECKOUT_SESSION_FAILURE:
            return {
                ...state,
                session: {
                    data: {},
                    loading: true,
                    error: action.error,
                    inputData: {},
                    loadingButtonContent: null,
                    buttonDisable: false,
                },
            };

        case SET_BOOKING_PAYMENT_SUCCESS_START:
            return {
                ...state,
                bookingSuccess: {
                    inputData: action.data,
                    data: {},
                    loading: true,
                    error: false,
                    loadingButtonContent: "Loading... Please wait",
                    buttonDisable: true,
                },
            };
        case SET_BOOKING_PAYMENT_SUCCESS_SUCCESS:
            return {
                ...state,
                bookingSuccess: {
                    data: action.data,
                    loading: false,
                    error: false,
                    inputData: {},
                    loadingButtonContent: null,
                    buttonDisable: false,
                },
            };
        case SET_BOOKING_PAYMENT_SUCCESS_FAILURE:
            return {
                ...state,
                bookingSuccess: {
                    data: {},
                    loading: true,
                    error: action.error,
                    inputData: {},
                    loadingButtonContent: null,
                    buttonDisable: false,
                },
            };

        case SET_BOOKING_PAYMENT_FAILED_START:
            return {
                ...state,
                bookingFailed: {
                    inputData: action.data,
                    data: {},
                    loading: true,
                    error: false,
                    loadingButtonContent: "Loading... Please wait",
                    buttonDisable: true,
                },
            };
        case SET_BOOKING_PAYMENT_FAILED_SUCCESS:
            return {
                ...state,
                bookingFailed: {
                    data: action.data,
                    loading: false,
                    error: false,
                    inputData: {},
                    loadingButtonContent: null,
                    buttonDisable: false,
                },
            };
        case SET_BOOKING_PAYMENT_FAILED_FAILURE:
            return {
                ...state,
                bookingFailed: {
                    data: {},
                    loading: true,
                    error: action.error,
                    inputData: {},
                    loadingButtonContent: null,
                    buttonDisable: false,
                },
            };

        case FETCH_MY_EVENT_BOOKINGS_START:
            return {
                ...state,
                myEventBookings: {
                    data: {},
                    loading: true,
                    inputData: action.data,
                    error: false,
                },
            };
        case FETCH_MY_EVENT_BOOKINGS_SUCCESS:
            return {
                ...state,
                myEventBookings: {
                    data: action.data,
                    loading: false,
                    error: false,
                    inputData: {},
                },
            };
        case FETCH_MY_EVENT_BOOKINGS_FAILURE:
            return {
                ...state,
                myEventBookings: {
                    inputData: {},
                    data: {},
                    loading: false,
                    error: true,
                },
            };


        default:
            return state;
    }
}
export default EventReducer;